// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import Swiper from "swiper/bundle";
//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./slider-text-on-bg.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const sliderTextOnBg = () => {
    let allSliderTextOnBg = document.querySelectorAll(".slider-text-on-bg");

    if (!allSliderTextOnBg.length) return;

    allSliderTextOnBg.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        let slidersNum = 0;

        // if (el.classList.contains("slider-single")) {
        //     slidersNum = 3;
        // } else {
        //     slidersNum = 4;
        // }

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 24,
                },
                390: {
                    slidesPerView: 1.2,
                    spaceBetween: 24,
                },
                450: {
                    slidesPerView: 1.4,
                    spaceBetween: 24,
                },
                530: {
                    slidesPerView: 1.6,
                    spaceBetween: 24,
                },
                570: {
                    slidesPerView: 1.8,
                    spaceBetween: 24,
                },
                688: {
                    slidesPerView: 2.2,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2.4,
                    spaceBetween: 30,
                },
                800: {
                    slidesPerView: 2.4,
                    spaceBetween: 30,
                },
                1160: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },

            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },

            pagination: {
                el: pagination,
                dynamicBullets: true,
                clickable: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

export default sliderTextOnBg;

//--------------------------------------------------------------------//
